import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';
import { ROUTE_TOKEN_ENGAGEMENTS_BASE } from '../../../../routing-constants';

export class EngagementDeletedStrategyModel implements EngagementErrorDialogDataModel {

  engagementId: number;

  constructor(engagementId: number) {
    this.engagementId = engagementId;
  }

  getTitle() { return 'Sorry, this engagement has been deleted.'; }
  getMessage() { return null; }
  getImagePath() { return 'deleted.png'; }
  getButtonText() { return 'Okay'; }
  getRoutePath() { return `${ROUTE_TOKEN_ENGAGEMENTS_BASE}`; }
}
